howspace.commentsTrait.commentsViewHandler = (() => {
    'use strict';

    const createViewsIdleTimeoutInMs = 5000; // How long the situation has to be idle before creating the views.
    const createdViews = {}; // Comment and reply IDs that have been viewed.

    let createViewsTimeoutId = null;
    let createViewsDataPayload = {};

    // Make sure that viewed comments/replies are removed from the data payload.
    real.onTierReady(real.TIER_2, () => {
        real.events.on('comment:views:created', notification => {
            notification.object.comments.forEach(commentId => {
                delete createViewsDataPayload[commentId];
            });
        });
    });

    // Confirm leaving the page while there are still views to be created.
    // window.addEventListener('beforeunload', (e) => {
    //     if (Object.keys(createViewsDataPayload).length > 0) {
    //         e.preventDefault();
    //     }
    // });

    const observeViews = (widget) => {
        if (!widget.data('are-views-shown')) {
            return;
        }

        widget.find('.comments [data-user-has-viewed="0"]').each(function () {
            howspace.visibilityObserver.observeVisibility(this);
        });
    }

    const addView = (elem) => {
        if (elem instanceof jQuery) {
            elem = elem[0];
        }

        elem.dataset.userHasViewed = '1';
        howspace.visibilityObserver.unobserveVisibility(elem);

        const elemId = elem.dataset.id;
        if (createdViews[elemId]) {
            return;
        }

        createdViews[elemId] = true;
        let commentId = elemId;
        let replyId = null;
        if (elem.classList.contains('reply')) {
            replyId = commentId;
            commentId = elem.closest('.comment').dataset.id;
        }

        const widget = elem.closest('.widget');
        createViewsDataPayload[elemId] = {
            page: real.dom.$body.data('page-id'),
            widget: {
                id: howspace.widgets.getId(widget),
                type: howspace.widgets.getType(widget)
            },
            comment: commentId,
            reply: replyId
        };

        if (createViewsTimeoutId !== null) {
            clearTimeout(createViewsTimeoutId);
        }
        createViewsTimeoutId = setTimeout(createViews, createViewsIdleTimeoutInMs);
    };

    const createViews = () => {
        if (Object.keys(createViewsDataPayload).length === 0) {
            return;
        }

        real.ajax.json(real.baseUri + '/api/comment-views', {
            data: JSON.stringify(createViewsDataPayload),
            type: 'POST',
            showErrorNotification: false,
        });

        // Clean the data payload.
        createViewsDataPayload = {};
    };

    return {
        observeViews: observeViews,
        addView: addView
    };
})();
